import React from 'react';
import Box, { BoxProps } from 'ui-box';
import { Card, defaultFills, Icon } from '../../npaper';
import { IOrganisation } from '../../stores';

export const OrganisationIcon = ({
  organisation,
  ...props
}: { organisation: IOrganisation } & BoxProps<'div'>) => {
  return (
    <Card
      width={50}
      height={50}
      background="white"
      borderRadius={6}
      flexShrink={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
      {...props}
    >
      {organisation.icon ? (
        <Box
          is="img"
          src={organisation.icon.small}
          width="100%"
          height="100%"
          style={{ objectFit: 'contain' }}
        />
      ) : (
        <Icon icon="office" color={defaultFills.muted} />
      )}
    </Card>
  );
};
